import React from "react";
import {connect} from "react-redux";
import Footer from "../components/Footer";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class FooterContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshPageController: false
        }
    }

    render() {
        return (
            <div>
                <Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FooterContainer);


// WEBPACK FOOTER //
// ./src/container/FooterContainer.js